import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  children: ReactNode;
};

export class PopoverPortal extends React.Component<Props> {
  modalRoot: HTMLElement | null = null;

  constructor(props: Props) {
    super(props);
    this.element = document.createElement('div');
  }

  componentDidMount() {
    this.modalRoot = document.getElementById('popover-root');
    if (this.modalRoot) {
      this.modalRoot.appendChild(this.element);
    }
  }

  componentWillUnmount() {
    if (this.modalRoot) {
      this.modalRoot.removeChild(this.element);
    }
  }

  element: HTMLElement;

  render() {
    return ReactDOM.createPortal(this.props.children, this.element);
  }
}
